import { useEffect, useState } from "react";
import { API } from "../data/siteData";

function newArticle() {
  return {
    title: "",
    slug: "",
    date: new Date().toISOString().slice(0, 10),
    author: "GAMEDAY Holdings LLC",
    category: "Company Update",
    summary: "",
    content: "",
    image_url: "",
    status: "draft",
  };
}

function cleanArticle(article) {
  if (!article) return newArticle();
  const { article_id: articleId, updated_at: updatedAt, ...fields } = article;
  void articleId;
  void updatedAt;
  return fields;
}

function formatError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || "Check the article fields.").join(" ");
  }
  return "The article could not be saved.";
}

export function getSaveLabel(article, state) {
  if (state === "loading") return "Saving…";
  return article ? "Save article" : "Create article";
}

export default function useNewsEditor(article, onSaved) {
  const [form, setForm] = useState(newArticle);
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => {
    setForm(cleanArticle(article));
    setError("");
    setState("idle");
  }, [article]);

  const update = (field, value) => {
    setForm((currentForm) => ({ ...currentForm, [field]: value }));
  };

  const saveArticle = async (event) => {
    event.preventDefault();
    setState("loading");
    setError("");
    try {
      const response = await fetch(`${API}/admin/news${article ? `/${article.article_id}` : ""}`, {
        method: article ? "PATCH" : "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(formatError(body.detail));
      await onSaved();
    } catch (saveError) {
      setError(saveError.message);
      setState("idle");
    }
  };

  return {
    error,
    form,
    saveArticle,
    state,
    update,
  };
}